import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/components/ui/require-permission'
import { Settings } from '@/features/settings'

export const Route = createFileRoute('/_authenticated/settings')({
  component: () => (
    <RequirePermission permission='settings.read'>
      <Settings />
    </RequirePermission>
  ),
})
